var scope_0 = require('/home/renato/github/renato145.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/61bfe46966fe27785d917382ddde8bd3.js').default;
var scope_1 = require('/home/renato/github/renato145.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a2e51d3b462b20a2371b706276c8f4b1.js').default;
var scope_2 = require('/home/renato/github/renato145.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e03e6b8592b31d0b9b4671c51dd863bc.js').default;
var scope_3 = require('/home/renato/github/renato145.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    